<script>

    import {onMount} from 'svelte';
    import domtoimage from 'dom-to-image';
    import Spinner from 'svelte-spinner';
    import {footerMessage, ts, today} from "./states/store.js";


    const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });


    let insetImage;
    let contentNode;
    let content;
    let files;
    let disabled = false;
    let enabledClass;




    $: if (!content) content = ""
    $: {
        if (content === "") {
            disabled = true
        } else {
            disabled = false
        }
    }
    $: {
        if (disabled) {
            enabledClass = ""
        } else {
            enabledClass = "hover:bg-red-600 hover:text-white";
        }
    }

    let fontSize = 36;
    let fontColor = "#000000";
    $: fontStyle = `font-size: ${fontSize}px; line-height: normal; color: ${fontColor};`



    function handlePaste(e) {
        if (e.clipboardData.files[0]) {
            if (!(contentNode === document.activeElement)) {
                const reader = new FileReader();
                reader.onloadend = function () {
                    insetImage = reader.result
                }
                reader.readAsDataURL(e.clipboardData.files[0]);
            }
        }
    }

    $: {
        if (files) {
            toBase64(files[0]).then(value => insetImage = value);
        }
    }


    const inputHandler = e => {
        e.target.style.height = "";
        e.target.style.height = e.target.scrollHeight + "px";
    }

    function adjustHeight(node) {
        node.addEventListener("input", inputHandler)
        return {
            destroy() {
                node.removeEventListener('input', inputHandler);
            }
        };
    }

    function toDataURL(url, callback) {
        let xhr = new XMLHttpRequest();
        xhr.onload = function () {
            let reader = new FileReader();
            reader.onloadend = function () {
                callback(reader.result);
            }
            reader.readAsDataURL(xhr.response);
        };
        xhr.open('GET', url);
        xhr.responseType = 'blob';
        xhr.send();
    }

    function refreshInset() {
        // https://picsum.photos/480/480，已经被墙。
        // https://placeimg.com/480/480/any，没有开放CORS，用/images/KEEVOL_Slogan.jpg代替
        // https://source.unsplash.com/random，不可用@2023
        toDataURL('/images/default.jpg', function (dataUrl) {
            insetImage = dataUrl;
        })
    }


    function download() {
        disabled = true;
        let node = document.getElementById("posterContainer")
        let scale = 540 / node.offsetWidth;

        domtoimage.toPng(node, {
            height: node.offsetHeight * scale,
            width: node.offsetWidth * scale,
            style: {
                transform: "scale(" + scale + ")",
                transformOrigin: "top left",
                width: node.offsetWidth + "px",
                height: node.offsetHeight + "px"
            }
        }).then(function (dataUrl) {
            try {
                let link = document.createElement("a");
                link.download = `keeposter-${ts()}.png`;
                link.href = dataUrl;
                link.click();
            } finally {
                disabled = false;
                content = "";
                refreshInset()
            }
        });
    }


    onMount(() => {
        refreshInset();
    });

</script>

<!--<svelte:head>-->
<!--    <link-->
<!--            rel="stylesheet"-->
<!--            href="https://cdn.jsdelivr.net/npm/tailwindcss@2.1.0/dist/tailwind.min.css"-->
<!--    />-->
<!--</svelte:head>-->

<svelte:window on:paste={handlePaste}/>

<div class="container px-5 py-3 mx-auto">
    <div class="lg:w-full mx-auto flex flex-wrap">
        <div class="md:w-1/2 w-full lg:pl-10 lg:py-6 mt-6 lg:mt-0">
            <h2 class="text-sm title-font text-gray-500 tracking-widest">In Tech We Trust</h2>
            <h1 class="text-gray-900 text-3xl title-font font-medium mb-1"><a href="https://www.keevol.cn">福强</a>海报
            </h1>
            <div class="flex mb-4"></div>
            <div class="border p-3">

                <div>
                    <textarea id="content" name="content"
                              class="p-2 text-2xl w-full text-black border resize-none"
                              placeholder="在这里输入海报内容..." bind:value={content} bind:this={contentNode}
                              use:adjustHeight></textarea>
                    <label for="fontSizer">调节字体大小</label>
                    <input id="fontSizer" type="range" min="12" max="111" bind:value={fontSize}>
                    <label for="fontColor">调节字体颜色</label>
                    <input type="color" id="fontColor" name="fontColor" bind:value={fontColor} />


                    <label class="mb-2 mt-6 text-gray-400" for="namer">在下面输入个人信息:</label>
                    <textarea rows="1" class="p-2 w-full text-black border resize-none"
                              placeholder="在这里留下自己的名字吧~"
                              id="namer" name="namer" bind:value={$footerMessage}></textarea>
                </div>

            </div>

            <div class="flex justify-center space-x-4 mt-3 w-full">
                <button class="w-full inline-flex items-center justify-center p-2 font-black {enabledClass}"
                        on:click={download} {disabled}>
                        <span>
                            生成并下载海报
                        </span>
                    {#if disabled && !(content === "")}
                        <Spinner/>
                    {/if}
                </button>
            </div>

        </div>


        <div class="md:w-1/2 w-full object-cover object-center rounded mt-3">


            <div class="relative">
                <div class="w-full object-cover mx-auto max-w-md">

                    <div id="posterContainer">

                        <div class="shadow-lg mx-auto relative max-w-sm group cursor-pointer">
                            <!--
                            <div class="absolute ml-4 pr-8 z-10">
                                <div class="bg-red-600 text-white bg-opacity-95 shadow px-2 py-1 flex items-center font-bold text-xs rounded">
                                    poster.keevol.cn
                                </div>
                            </div>
                                                        -->
                            <div class="overflow-hidden upload-btn-wrapper">
                                <img class="transform hover:scale-110 duration-200" src="{insetImage}" alt=""
                                     width="480" height="480" loading="lazy"/>
                                <input type="file" name="insetChooser" bind:files>
                            </div>


                            <!--                            <div class="pt-96 my-auto w-full bg-cover bg-center" style="background-image:url('{insetImage}');">-->
                            <!--                                <div class="overflow-hidden upload-btn-wrapper">-->
                            <!--                                    <input type="file" name="insetChooser" bind:files>-->
                            <!--                                </div>-->
                            <!--                                <p class="p-3 text-4xl font-black text-blue-600 bg-white opacity-75 whitespace-pre-wrap">-->
                            <!--                                    {content}-->
                            <!--                                </p>-->
                            <!--                            </div>-->
                            <p class="p-3 text-black bg-white opacity-75 whitespace-pre-wrap"
                               style={fontStyle}>
                                {content}
                            </p>
                            <div class="border-t pt-8 pb-8 text-center text-base text-gray-400 uppercase tracking-widest  group-hover:text-gray-600 bg-gray-50">
                                <span class="text-xl font-semibold text-gray-500 mt-4">{$footerMessage}</span>
                                <br>
                                <span class="text-sm font-semibold text-gray-500 mt-4">
                                    {today()}</span>
                                <!--
                                <span class="text-sm lowercase">created by</span> 奇趣海报
                                -->
                            </div>
                        </div>


                    </div>

                </div>


            </div>


        </div>
    </div>
    <footer>
        <div class="mt-11 mx-auto">
            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAACWAAAAAYAQMAAABEalRSAAAABlBMVEX///9TU1NYzE1OAAAAAXRSTlMAQObYZgAAAOtJREFUeF7tljEKwzAMRb/J0CWgI/QKOYAh1+pUcjQfpUfw2MFEHVyDQSQmQUNM9AYNcobnh4egU+YVqhAvZSpgsfolPnSv5d0nz3vHslgUdK81RLzyvHcsi+WBNxQh4Ln8pw4Wi7skAg9mXgHMrEACXJnbHIllsbqGAtwXhnYswzFzwPWxWEPc2CexoobkHM4ZpD6s2loWiyIEEwCChIomMiMEHqgP573C9eHkc5VLWh3XsljnGVoLWVl+31bp38piTVVuihtPOAm9kcRLbrFjEvqwamtZLK5eI8sSan9rXEK0LcNFrY5oWawf59S7YSRD7eMAAAAASUVORK5CYII="
                 style="max-width: 100%;height: auto;" alt/>

        </div>
        <div class="mt-6 mx-auto text-center">本海报工具由<a href="https://keevol.cn">杭州福强科技有限公司</a>免费提供技术实现和支持。
        </div>

        <div class="mt-6 mx-auto text-center">本海报工具使用指南与技巧可以参看<a
                href="https://www.bilibili.com/video/BV1pg411F7jQ?share_source=copy_web">b站视频</a>或者<a
                href="https://youtu.be/8I8dDPfvVQs">youtube视频</a></div>


        <div class="mt-6 mx-auto text-center">想要自己打造一个类似的Web应用？可以参考<a
                href="https://afoo.me/books.html#simple-svelte-a-frontend-book-from-a-backend-developer">《Simple
            Svelte》</a></div>
    </footer>

</div>


<!--<style>-->
<!--    .poster {-->
<!--        object-fit: cover;-->
<!--    }-->

<!--    .upload-btn-wrapper input[type=file] {-->
<!--        font-size: 100px;-->
<!--        position: absolute;-->
<!--        left: 0;-->
<!--        top: 0;-->
<!--        opacity: 0;-->
<!--        width: 100%;-->
<!--        height: 100%;-->
<!--    }-->
<!--</style>-->

<style lang="postcss" global>
    @tailwind base;
    @tailwind components;
    @tailwind utilities;

    .poster {
        object-fit: cover;
    }

    .upload-btn-wrapper input[type=file] {
        font-size: 100px;
        position: absolute;
        left: 0;
        top: 0;
        opacity: 0;
        width: 100%;
        height: 100%;
    }
</style>